import { Shape as ShapeType } from '../HighContrastMode/constants'

type ShapeProps = {
    cx: number
    cy: number
    stroke: string
    shape: ShapeType
    size?: number
}

export default function Shape({ cx, cy, stroke, shape, size = 4 }: ShapeProps) {
    const baseProps = { fill: stroke, stroke: 'white', strokeWidth: '1' }

    switch (shape) {
        case 'circle':
            return <circle cx={cx} cy={cy} r={size} {...baseProps} />

        case 'square':
            return (
                <rect
                    x={cx - size}
                    y={cy - size}
                    width={size * 2}
                    height={size * 2}
                    {...baseProps}
                />
            )

        case 'triangle':
            return (
                <polygon
                    points={`${cx},${cy - size - 1} ${cx - size - 1},${cy + size + 1} ${cx + size + 1},${cy + size + 1}`}
                    {...baseProps}
                />
            )

        case 'diamond':
            return (
                <polygon
                    points={`${cx},${cy - size} ${cx + size},${cy} ${cx},${cy + size} ${cx - size},${cy}`}
                    {...baseProps}
                />
            )

        case 'star': {
            const starPoints = Array.from({ length: 10 }, (_, i) => {
                const angle = (i * Math.PI) / 5
                const radius = i % 2 === 0 ? size : size / 2
                const x = cx + radius * Math.cos(angle - Math.PI / 2)
                const y = cy + radius * Math.sin(angle - Math.PI / 2)
                return `${x},${y}`
            }).join(' ')

            return <polygon points={starPoints} {...baseProps} />
        }

        case 'cross':
            return (
                <g>
                    <line
                        x1={cx - size}
                        y1={cy}
                        x2={cx + size}
                        y2={cy}
                        stroke="white"
                        strokeWidth="4"
                    />
                    <line
                        x1={cx}
                        y1={cy - size}
                        x2={cx}
                        y2={cy + size}
                        stroke="white"
                        strokeWidth="4"
                    />
                    <line
                        x1={cx - size}
                        y1={cy}
                        x2={cx + size}
                        y2={cy}
                        stroke={stroke}
                        strokeWidth="2"
                    />
                    <line
                        x1={cx}
                        y1={cy - size}
                        x2={cx}
                        y2={cy + size}
                        stroke={stroke}
                        strokeWidth="2"
                    />
                </g>
            )

        default:
            return <circle cx={cx} cy={cy} r={size} {...baseProps} />
    }
}
